import { v4 as uuid } from '@lukeed/uuid';
import { createElement, } from 'react';
import { Accordion } from '../accordion/Accordion';
import { DropZone } from '../drop-zone/DropZone';
import { Modal } from '../modal/Modal';
import { SplitPane } from '../split-pane/SplitPane';
const layoutComponents = {
    SplitPane,
    Accordion,
    Modal,
    DropZone,
};
export function LayoutManager(props) {
    const { layout, components } = props;
    return createLayout(layout, components);
}
function createLayoutComponent(com, components, props = {}) {
    const { id, component, children, ...compProps } = com;
    const componentId = id || uuid();
    const componentNode = findComponent(component, components);
    if (componentNode) {
        const componentProps = { id: componentId, ...compProps, ...props };
        const childrenComp = children && typeof children === 'string'
            ? children
            : createElements(children, components);
        return createElement(componentNode, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        componentProps, childrenComp);
    }
    return null;
}
function createLayout(layout, components) {
    return createLayoutComponent(layout.layout, components);
}
function createElements(children, components) {
    return children?.map((comp, index) => createLayoutComponent(comp, components, { key: index }));
}
function findComponent(component, definedComponents) {
    if (typeof component === 'function')
        return component;
    if (typeof component === 'string') {
        if (definedComponents?.[component])
            return definedComponents[component];
        if (layoutComponents[component])
            return layoutComponents[component];
    }
    return null;
}
//# sourceMappingURL=LayoutManager.js.map